var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgClock = function SvgClock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#333",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    d: "M8.7 8.7c-.4.4-1 .4-1.4 0s-.4-1 0-1.4 1-.4 1.4 0 .4 1 0 1.4M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8m0 14c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 6.3,
    x: 7,
    y: 2.7,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    width: 2,
    height: 6,
    x: 8.957,
    y: 5.642,
    rx: 1,
    transform: "rotate(-75 9.957 8.642)"
  }))));
};
export default SvgClock;